import { render } from "./RatingStars.vue?vue&type=template&id=3c38695a&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"

import "./RatingStars.vue?vue&type=style&index=0&id=3c38695a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c38695a"]])

export default __exports__